import React from 'react'
import Body from '../components/Body/Body'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Home = () => {
    return (
        <>
            <Navbar/>
            <Header/>
            <Body/>
            <Footer/>
        </>
    )
}

export default Home
